<template>
<div class="chapter">
<div class="inner_page">
<div class="wrap"><div class="illustration"><img alt="image" src="images/img036.jpg"/>
<p class="figcap"><b><i>Spirit Search</i></b> </p></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1a.vue?5b891bfd